var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS } from "./rentRegistrationDocuments.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, isFetchingCount = _a.isFetchingCount, fetchCountError = _a.fetchCountError, getCreatedDetail = _a.getCreatedDetail, isCreating = _a.isCreating, createError = _a.createError, 
// isUpdating,
// updateError,
isRemoving = _a.isRemoving, removeError = _a.removeError;
export var isUpdating = function (state, id) {
    var _a, _b, _c, _d;
    return id !== undefined
        ? (_d = (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.isUpdating) !== null && _d !== void 0 ? _d : false
        : false;
};
export var updateError = function (state, id) {
    var _a, _b, _c, _d;
    return id !== undefined
        ? (_d = (_c = (_b = (_a = state[GENERATOR_PARAMS.reducerKey]) === null || _a === void 0 ? void 0 : _a.registrationsById) === null || _b === void 0 ? void 0 : _b[id]) === null || _c === void 0 ? void 0 : _c.updateError) !== null && _d !== void 0 ? _d : false
        : false;
};
